export default __webpack_public_path__ + "images/indeed-logo-9c6a8b.svg";